// The ads-library backend can only monitor pages addressable by a numeric
// Facebook page ID. Free-text/ads-archive-derived results carry a slug/handle
// (e.g. "archi-ge") which the save endpoint rejects with a 400.
export const isNumericPageId = (id?: string | null): boolean =>
  !!id && /^\d+$/.test(id)
